<template>
	<div>
		<div class="pd20" style="height: calc(100vh - 60px);">
			<a-spin :spinning="loading">
				<div class="pd20 bg-w" style="height: 100%;">
					<div class="flex center ft18 cl-main">订单详情</div>
					<div class="mt20">
						<div class="flex alcenter space">
							<div class="flex alcenter">
								<div class="">
									<div class="flex alcenter">
										<div class="flex alcenter">
											<div class="ft14 ftw400 cl-info">订单编号：</div>
											<div class="ft14 ftw600 cl-main">{{order.order_id}}</div>
										</div>

										<div class="flex alcenter ml40">
											<div class="ft14 ftw400 cl-info">下单时间：</div>
											<div class="ft14 ftw600 cl-main">{{order.add_time_format}}</div>
										</div>
									</div>
								</div>
							</div>
							<div>
								<a-button type="default" @click="$router.go(-1)">返回</a-button>
							</div>
						</div>

						<div class="mt30">
							<div class="cash-order-detail-info">
								<div class="flex ">
									<div class="pl40" style="width: 33%;border-right: 1px solid #EBEDF5;">
										<div class="ft14 ftw500 cl-main">订单状态</div>
										<div class="ft20 ftw600 cl-theme mt16" v-if="order.status==1">待付款</div>
										<div class="ft20 ftw600 cl-theme mt16" v-if="order.status==2">已支付</div>
										<div class="ft20 ftw600 cl-theme mt16" v-if="order.status==-1">已取消</div>
										<div class="big-button-pay mt16" @click="cancelOrderAct()" v-if=" order.status==0">取消订单
										</div>
									</div>
									<div class="" style="width: 33%;">
										<div class="flex" style="border-right: 1px solid #EBEDF5; ">
											<div class="ml40 text-over4">
												<div class="ft14 ftw500 cl-main text-over4">付款信息</div>
												<div class="mt16">
													<div class="flex">
														<div>
															<div class="flex alcenter">
																<div class="ft14 ftw400 cl-info text-over4">实付金额：</div>
																<div class="ft14 ftw600 cl-main text-over4">
																	¥{{order.need_pay}}</div>
															</div>
															<div class="flex alcenter mt10">
																<div class="ft14 ftw400 cl-info text-over4">支付方式：</div>
																<div class="ft14 ftw600 cl-main text-over4">
																	{{order.pay_type_mean}}
																</div>
															</div>
															<div class="flex alcenter mt10">
																<div class="ft14 ftw400 cl-info text-over4">支付时间：</div>
																<div class="ft14 ftw600 cl-main text-over4">
																	{{order.pay_time_format}}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="" style="width: 33%;">
										<div class="ml40">
											<div class="ft14 ftw500 cl-main">客户信息</div>
											<div class="mt16">
												<div class="flex" v-if="order.member">
													<div>
														<div class="flex alcenter">
															<div class="ft14 ftw400 cl-info text-over4">客户姓名：</div>
															<div class="ft14 ftw600 cl-main text-over4">
																{{order.member_name}}
															</div>
														</div>
														<div class="flex alcenter mt10">
															<div class="ft14 ftw400 cl-info text-over4">手机号码：</div>
															<div class="ft14 ftw600 cl-main text-over4">
																{{order.member_mobile}}
															</div>
														</div>
													</div>
												</div>
												<div class="flex" v-else>
													<div class="ft16 ftw600 cl-main text-over4">
														游客
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="mt30">
							<div class="flex wrap">
								<div class="cash-order-detail-subcard-item" v-for="(item,index) in order.items">
									<div class="flex  alcenter space">
										<div class="flex alcenter">
											<img v-if="item.goods_cover_img != null" :src="item.goods_cover_img" />
											<div class="ml10">
												<div class="ft14 ftw500 cl-info" style="width: 60%;">

													{{item.goods_name}}
												</div>
												<div class="ft12 ftw400 cl-notice">{{item.goods_sku_name}}</div>
											</div>
											<div style="margin-left: 200px;" class="ft14 ftw500 cl-info flex alcenter">
												<div>¥{{item.goods_price}}</div>
												<div class="ml8">x{{item.goods_num}}</div>
											</div>
										</div>
										<div></div>
									</div>
								</div>
							</div>
						</div>

						<div class="flex end mt10">
							<div class="flex">
								<div class="ft12 ftw400 cl-info">
									<div class="flex end">合计</div>

									<div class="flex end mt8" v-if="order.coupon_money>0">优惠券抵扣</div>

									<div class="flex end mt8" v-if="order.youhui_balance > 0">优惠金额</div>
									<div class="flex end mt8 ft14 ftw500 cl-black">订单金额</div>
								</div>

								<div class="ml60 ft12 ftw400 cl-info">
									<div class="flex end">¥{{order.total_price}}</div>
									<div class="flex end mt8" v-if="order.coupon_money>0">¥{{order.coupon_money}}</div>

									<div class="flex end mt8" v-if="order.youhui_balance > 0">¥{{order.youhui_balance}}
									</div>
									<div class="flex end mt8 ft14 ftw500 cl-black">¥{{order.need_pay}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a-spin>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				order_id: 0,
				order: {
					order_id: 0,
					add_time_format: '',
					order_type_means: '',
					status: 0,
					status_means: '',
					need_pay: 0,
					pay_type_mean: '',
					pay_time_format: '',
					total_price: 0,
					coupon_money: 0,
					member: {},
					member_name: '',
					member_mobile: '',
					items: []
				}
			}
		},
		created() {
			if (!this.$route.query.id) {
				this.order_id = 0;
			} else {
				this.order_id = parseInt(this.$route.query.id);
			}
			this.loaddata();
		},
		methods: {
			loaddata() {
				if (this.loading == true) return;
				this.loading = true;
				this.$http.api('getOrderDetail', {
					order_id: this.order_id
				}).then(res => {
					this.order = res.detail;
					this.loading = false;
				}).catch(res => {
					console.log(res);
					this.loading = false;
					this.$router.go(-1);
				})
			},
			cancelOrderAct(){
				this.$confirm({
					title:'确定取消这个订单吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('cancelOrder',{
								order_id:this.order_id,
							}).then(res=>{
								this.$message.success('取消成功',1,()=>{
									this.getLists();
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
		}
	}
</script>

<style>
	.cash-order-detail-tag {
		padding: 1px 8px;
		border-radius: 2px;

		font-size: 12px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 16px;
	}

	.cash-order-detail.tag {
		padding: 1px 4px;
		background: rgba(71, 114, 255, 0.1);
		border-radius: 2px;

		font-size: 12px;
		font-weight: 500;
		color: #4772FF;
	}


	.cash-order-detail-info {
		background: #F9F9F9;
		border: 1px solid #EBEDF5;
		padding: 24px 0px;
	}

	.cash-order-detail-subcard-item {
		width: 100%;
		height: 100px;
		background: #FFFFFF;
		border: 1px solid #EBEDF5;
		margin-bottom: 20px;
		padding: 20px;
	}

	.cash-order-detail-subcard-item img {
		width: 75px;
		height: 60px;
	}
</style>
